// services/reactions.js

import axios from './axios';

export async function fetchReactions(postId) {
  const res = await axios.get(`/api/reactions/?post=${postId}`);
  return res.data;
}

export async function fetchReactionTypes() {
  const res = await axios.get(`/api/reaction-types/`);
  return res.data;
}

export async function sendReaction(postId, reactionTypeId) {
  const res = await axios.post(`/api/reactions/`, {
    post: postId,
    reaction_type_id: reactionTypeId
  });
  return res.data;
}

export const deleteReaction = (reactionId) =>
  axios.delete(`/api/reactions/${reactionId}/`);
